import { query } from '@kurtosys/ksys-app-template';
import { StoreContext } from '../../../configuration/StoreContext';
import { QueryContext } from '@kurtosys/ksys-api-client/dist/query/QueryContext';
import { observable, action, computed } from 'mobx';
import { QueryStore as QueryStoreBase } from '@kurtosys/ksys-app-components/dist/shared/QueryStore';
import { IQueryOptions, IExecutionOptions, IQueryContext, IQueryContextCulture } from '../../../models/commonTypes';
import { IInputs } from '../../../models/app/IInputs';
import { IQueryContextClient } from '@kurtosys/ksys-api-client/dist/models/query/IQueryContextClient';
const Query = query.Query;
export class QueryStore extends QueryStoreBase {
	storeContext: StoreContext;
	@observable.ref context: IQueryContext | undefined = undefined;

	constructor(storeContext: StoreContext) {
		super();
		this.storeContext = storeContext;
	}

	@computed
	get queryContext(): QueryContext | undefined {
		const queryContextConfiguration = this.queryContextConfiguration;
		if (queryContextConfiguration) {
			const queryContext = new QueryContext(queryContextConfiguration);
			return queryContext;
		}
	}

	@computed
	get queryContextConfiguration() {
		const { appStore } = this.storeContext;
		const { configuration } = appStore;
		if (configuration && configuration.data && configuration.data.context) {
			return configuration.data.context;
		}
	}

	@computed
	get client(): IQueryContextClient {
		const { kurtosysApiStore } = this.storeContext;
		return kurtosysApiStore.client;
	}

	get inputs() {
		const { appStore } = this.storeContext;
		const { appParamsHelper } = appStore;
		return appParamsHelper.inputs;
	}

	@computed
	get executionOptions(): IExecutionOptions {
		const { appStore, translationStore } = this.storeContext;
		return {
			context: this.context,
			culture: appStore.getInput('culture'),
			fallbackCulture: appStore.configuration && appStore.configuration.culture && appStore.configuration.culture.default,
			translate: translationStore.translate,
			inputs: this.inputs,
		};
	}
	@action async initialize() {
		const { appStore, kurtosysApiStore } = this.storeContext;
		const { configuration, appParamsHelper, dataContextSeed } = appStore;
		if (configuration && configuration.data && configuration.data.context) {
			const queryContext = new QueryContext(configuration.data.context, dataContextSeed);
			const inputs: IInputs | undefined = appParamsHelper.inputs;
			const queryContextCulture: IQueryContextCulture = {
				sourceCulture: (configuration && configuration.culture && configuration.culture.base) || 'en-GB',
				targetCulture: (inputs && inputs.culture) || (configuration && configuration.culture && configuration.culture.default) || 'en-GB',
			};
			this.context = await queryContext.fetch(kurtosysApiStore.client, inputs || {}, queryContextCulture);
		}
	}
	query(options?: IQueryOptions, overrideExecutionOptions?: Partial<IExecutionOptions>) {
		if (options) {
			const { translationStore } = this.storeContext;
			const translationHelper = translationStore && translationStore.translationHelper;
			const query = new Query(options, translationHelper);
			const workingExecutionOptions = query.mergeExecutionOptions(this.executionOptions, overrideExecutionOptions || {});
			const queryResponse = query.execute(workingExecutionOptions);
			return queryResponse;
		}
	}
	async entitiesRequest(id: string, inputs: object) {
		const queryContext = this.queryContext;
		const queryContextConfiguration = this.queryContextConfiguration;
		if (queryContext && queryContextConfiguration) {
			return await queryContext.fetchEntities(this.client, id, inputs, queryContextConfiguration, this.executionOptions);
		}
	}
}